<div
  class="min-h-screen min-w-[100vw] flex items-center justify-center bg-gradient-to-br from-blue-900 to-blue-400 p-6">

  <div class="w-full max-w-xl bg-white rounded-3xl shadow-2xl p-10 border border-gray-100">

    <div class="mb-8 text-left">
      <h2 class="text-3xl font-extrabold text-gray-900 tracking-tight">Connexion</h2>
      <p class="text-gray-500 mt-2">Veuillez entrer vos identifiants pour accéder à votre tableau de bord.</p>
    </div>



    <form class="space-y-6">
      <div>
        <label class="block text-sm font-semibold text-gray-700 mb-2">Utilisateur</label>
        <input type="text" [(ngModel)]="nameUser" name="login" placeholder="Ex: johndoe"
          class="w-full px-4 py-3 rounded-xl border border-gray-200 focus:ring-4 focus:ring-blue-500/20 focus:border-blue-500 transition-all outline-none" />
      </div>

      <div>
        <label class="block text-sm font-semibold text-gray-700 mb-2">Mot de passe</label>
        <input (keydown.enter)="connection()" type="password" [(ngModel)]="passwordUser" name="password"
          placeholder="••••••••"
          class="w-full px-4 py-3 rounded-xl border border-gray-200 focus:ring-4 focus:ring-blue-500/20 focus:border-blue-500 transition-all outline-none" />
      </div>

      <div *ngIf="errorMessage"
        class="bg-red-50 border border-red-200 text-red-600 px-4 py-3 rounded-lg text-sm font-medium ">
        {{ errorMessage }}
      </div>

      <button type="button" [disabled]="disabledBtnConnection" (click)="connection()"
        class="w-full bg-blue-600 hover:bg-blue-700 disabled:opacity-50 text-white font-bold py-3.5 rounded-xl transition-all shadow-lg shadow-blue-500/30 active:scale-[0.97]">
        {{ disabledBtnConnection ? 'Connexion en cours...' : 'Se connecter' }}
      </button>
    </form>
  </div>
</div>